var exports = {
  "KK": "viewSwitch__eVlS4z",
  "vj": "tabNav__P8vAGk",
  "gj": "tabList__ud6oLF",
  "HX": "tabNavLink__58OJcs",
  "vu": "active__1LHN62",
};

module.exports = exports;
